module.exports = __webpack_public_path__ + "img/hf.e5f8168c.png";